import { IWindowService } from 'angular';
import { SpinnerModal } from '../../../../shared/modals/status-spinner/status-spinner.service';
import { SdcActionsService } from './../../../flux/sdc-actions.service';
import { ISdcStore } from './../../../flux/sdc-store.interface';

export class GradPlanningWizardTransferCtrl {
  static $inject: string[] = ['$scope', 'SpinnerModal', 'SDCStore', 'sdcActions', '$window'];

  // bindings
  currentSchool: any;
  currentUser;
  uiReady;

  constructor(
    private $scope,
    private spinnerModal: SpinnerModal,
    private SDCStore: ISdcStore,
    private sdcActions: SdcActionsService,
    private $window: IWindowService,
  ) {}

  $onInit(): void {
    this.$scope.$listenTo(this.SDCStore, ['ui', 'isLoading'], () => {
      const isLoading = this.SDCStore.getUiState().isLoading;
      if (!isLoading) {
        this.spinnerModal.deactivateSpinner();
        this.uiReady = true;
      }
    });
  }
}
